import { render, staticRenderFns } from "./transition-fade.vue?vue&type=template&id=2e070139&"
import script from "./transition-fade.vue?vue&type=script&lang=js&"
export * from "./transition-fade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports